<template>
  <div class="page" id="loginPage">
    <div class="login-logo"></div>
    <div class="login-wrap">
      <el-form :model="ruleForm" ref="ruleForm" class="login-container">
        <div class="fl title">Get a new account</div>
        <div class="sub-username ft-16" style="margin-top: 50px">
          User Account
        </div>
        <el-form-item prop="username" style="margin-top: 10px">
          <el-input class="login-input" type="text" v-model="ruleForm.username" auto-complete="off"
            placeholder="Enter your e-mail">
          </el-input>
          <div class="input-tip ft-16">Ensure that the email address can receive email messages.</div>
        </el-form-item>

        <div class="sub-glcuoseMeter ft-16">
          My Glucose Meters
        </div>
        <el-form-item prop="sns" style="margin-top: 10px">
          <el-input class="login-input" type="text" v-model="ruleForm.sns" auto-complete="off"
            placeholder="Enter meter serial number">
          </el-input>
          <div class="input-tip ft-16">Please use the "/" following the glucose meter serial number if you'd like to key into more than one glucose meter.</div>
        </el-form-item>
        <el-form-item style="width: 100%; margin-top: 20px">
          <el-button type="primary" class="register-button" @click="submitForm()">Submit</el-button>
          <div class="back-item" @click="handleBackToLogin()">Back to log in</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
 
<script>
import { post } from "@/script/api.js";
import { JSEncrypt } from 'jsencrypt'

export default {
  components: {},
  props: {
    // isAdminLogin:Boolean,
  },
  data() {
    return {
      ruleForm: {
        username: "",
        sns: "",
      },

    };
  },
  mounted() {

  },

  methods: {


    submitForm() {
      if (!this.ruleForm.username) {
        this.$message.error("Please enter your user account");
        return false;
      }
      var emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
      // 使用正则表达式进行验证
      if (!emailRegex.test(this.ruleForm.username)) {
        this.$message.error("Please enter the correct email format");
        return false;
      }
      if (!this.ruleForm.sns) {
        this.$message.error("Please enter meter serial number");
        return false;
      }
      // return;
      post("register", {
        email: this.ruleForm.username,
        sns: this.ruleForm.sns
      }).then((res) => {
        console.log("注册结果", res);
        if (res.code == 0) {
          this.$message.success('Created successfully, the email has been sent to your mailbox');
          window.history.go(-1);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleBackToLogin() {
      window.history.go(-1);
    },
  },
};
</script>

<style scoped>
#loginPage {
  background: url("../assets/images/login-bg.jpg") no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-style: normal;
  font-weight: 400;
  height: 100vh;
}

.login-logo {
  background: url("../assets/images/logo.png") no-repeat;
  width: 309px;
  height: 46px;
}

.login-container {
  border-radius: 15px;
  margin: 40px auto;
  width: 580px;
  padding: 30px 65px 15px 65px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
}

.title {
  margin: 0px auto auto auto;
  color: black;
  font-weight: 700;
  font-style: normal;
  font-size: 22px;
}

.login-input>>>.el-input__inner {
  height: 50px;
  border: 1px solid lightgray;
  width: 100%;
  border-radius: 6px;
  padding-left: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
}

.input-tip {
  margin-top: 15px;
  color: lightgray;
  line-height: 1.1;
}

.register-button {
  width: 100%;
  height: 50px;
  margin-top: 20px;
  background-color: rgb(148, 200, 66);
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
}

.back-item {
  width: 100%;
  height: 50px;
  margin-top: 20px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Register.vue